























































import Vue from 'vue'
import { mapActions, mapMutations } from 'vuex'
import { VueForm } from '@/utils/interfaces'
import { generateQR, checkCode } from '@/api/Auth/auth.api'
import { identifyLogrocket, identifySentry } from '@/utils/functions'
import TextButton from '~/components/TextButton.vue'
import { mask } from 'vue-the-mask'

export default Vue.extend({
  components: {
    TextButton,
  },
  props: {
    firstTime: Boolean,
  },
  directives: { mask },
  data: function() {
    return {
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
      },
      crud: {
        pin: '',
      },
      loading: false,
      success: false,
      wrongCredentials: false,
      loadingQr: false,
      qrImage: '',
    }
  },
  methods: {
    ...mapActions(['getProfileInfo']),
    ...mapMutations({ updateTokens: 'UPDATE_ACCESS' }),
    async onLogin(): Promise<void> {
      if (!(this.$refs.form as VueForm).validate()) return
      this.loading = true
      try {
        const response = await checkCode(this.crud.pin)
        this.updateTokens(response.data)
        await this.getProfileInfo()
        this.$i18n.locale = this.$store.getters.profile.lang
        this.$vuetify.lang.current = this.$store.getters.profile.lang
        if (this.$store.getters.profile.role === 'admin') {
          identifyLogrocket(this.$store.getters.profile)
        }
        identifySentry()
        this.$router.push({ name: 'dashboard' })
      } catch {
        this.wrongCredentials = true
        setTimeout(() => {
          this.wrongCredentials = false
        }, 3000)
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    try {
      if (this.firstTime) {
        this.loadingQr = true
        const response = await generateQR()
        this.qrImage = response.data.code
      }
    } finally {
      this.loadingQr = false
    }
  },
})
